import { faRobot } from "@fortawesome/pro-duotone-svg-icons/faRobot";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_AGENTS_LINK: Breadcrumb = {
  icon: faRobot,
  name: "Agents",
  to: "/dashboard/agents",
};
